import React from "react";
import Seo from "../../components/utils/Seo";
import Base from "../Base";
import BodyProducts from "./BodyProducts";

const ProductsPage = (props) => {
  return (
    <div>
      <Seo
        title="nti / articles"
        description="Tous vos articles informatique en un seul endroit"
      />
      <Base>
        <BodyProducts />
      </Base>
    </div>
  );
};

export default ProductsPage;
